export default __webpack_public_path__ + "static/media/PlanAboutToExpire.47641621.svg";